/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */

// libraries
import { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// api
import api from 'pages/Articles/api';

interface UseArticles {
  articles: any;
  handleRelatedArticleClick: (url: string) => () => void;
}

const useArticles = ({ forHomePage, forServicePage, categories, serviceId }: any): UseArticles => {
  const history = useHistory();

  const [articles, setArticles] = useState([]);

  useEffect(() => {
    (async (): Promise<any> => {
      try {
        const articles = await api.getArticles(forHomePage, forServicePage, categories, serviceId);

        setArticles(articles.data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [forHomePage, forServicePage, categories, serviceId]);

  const handleRelatedArticleClick = useCallback(
    (url: string) => (): void => {
      // @ts-ignore
      gtag('event', 'Related Article Click', {
        event_category: forHomePage ? 'Home' : 'Service',
        event_label: url,
      });
      history.push(`/learn/${url}`);
    },
    [history, forHomePage],
  );

  return { articles, handleRelatedArticleClick };
};

export default useArticles;
